import { Component, Input } from '@angular/core';
import { SinglePopupService } from '../../common/single-popup.service';
import { filter } from 'rxjs/operators/filter';
/**
 * @hidden
 */
var DateFilterMenuInputComponent = /** @class */ (function () {
    function DateFilterMenuInputComponent(popupService) {
        this.popupService = popupService;
        this.operators = [];
    }
    DateFilterMenuInputComponent.prototype.open = function (picker) {
        this.subscription = this.popupService.onClose
            .pipe(filter(function () { return picker.isActive; }))
            .subscribe(function (e) { return e.preventDefault(); });
    };
    DateFilterMenuInputComponent.prototype.ngOnDestroy = function () {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    };
    DateFilterMenuInputComponent.decorators = [
        { type: Component, args: [{
                    selector: 'kendo-grid-date-filter-menu-input',
                    template: "\n        <kendo-grid-filter-menu-input-wrapper\n            [column]=\"column\"\n            [filter]=\"filter\"\n            [operators]=\"operators\"\n            [defaultOperator]=\"operator\"\n            [currentFilter]=\"currentFilter\"\n            [filterService]=\"filterService\"\n            >\n            <kendo-datepicker\n                #picker\n                kendoFilterInput\n                (open)=\"open(picker)\"\n                [value]=\"currentFilter?.value\"\n                [placeholder]=\"placeholder\"\n                [formatPlaceholder]=\"formatPlaceholder\"\n                [format]=\"format\"\n                [min]=\"min\"\n                [max]=\"max\"\n                [activeView]=\"activeView\"\n                [bottomView]=\"bottomView\"\n                [topView]=\"topView\"\n                >\n            </kendo-datepicker>\n        </kendo-grid-filter-menu-input-wrapper>\n    "
                },] },
    ];
    /** @nocollapse */
    DateFilterMenuInputComponent.ctorParameters = function () { return [
        { type: SinglePopupService, },
    ]; };
    DateFilterMenuInputComponent.propDecorators = {
        'operators': [{ type: Input },],
        'column': [{ type: Input },],
        'filter': [{ type: Input },],
        'operator': [{ type: Input },],
        'currentFilter': [{ type: Input },],
        'filterService': [{ type: Input },],
        'format': [{ type: Input },],
        'formatPlaceholder': [{ type: Input },],
        'placeholder': [{ type: Input },],
        'min': [{ type: Input },],
        'max': [{ type: Input },],
        'activeView': [{ type: Input },],
        'bottomView': [{ type: Input },],
        'topView': [{ type: Input },],
    };
    return DateFilterMenuInputComponent;
}());
export { DateFilterMenuInputComponent };



//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/@progress/kendo-angular-grid/dist/es/filtering/menu/date-filter-menu-input.component.js
// module id = ../../../../@progress/kendo-angular-grid/dist/es/filtering/menu/date-filter-menu-input.component.js
// module chunks = vendor